import React from 'react';
import Navbar from './navbar';
import CustomerList from './CustomerList.js'
import Header from './Header';
import './App.css';


export default function Home()
{
    
    return(
        <>
            <div style={{position:"fixed", top:"0", width:"100%",zIndex:1}}>
             
            <Header/>
            <Navbar />
            </div>
            <div style={{backgroundColor:"snow",borderStyle:"outset"}}>
            <CustomerList/>
            </div>
        </>)
}
